import React from 'react';

/**
 * 加载指示器组件
 */
const LoadingSpinner: React.FC = React.memo(() => (
    <div className="search-pdf-toolbar-loading" role="status" aria-label="loading">
        <div className="loading-spinner" aria-hidden="true" />
    </div>
));

LoadingSpinner.displayName = 'LoadingSpinner';

export { LoadingSpinner };

